import { BASE_URL } from 'config';
// src/layouts/users/data/usersTableData.js
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAvatar from "components/MDAvatar";
import MDBadge from "components/MDBadge";
import Switch from "@mui/material/Switch";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { styled } from "@mui/material/styles";
import { useState } from "react";
import IconButton from "@mui/material/IconButton";
import AddUserModal from "components/AddUserModal";
import axios from "axios";
import Swal from "sweetalert2";
import { Person as PersonIcon } from "@mui/icons-material"; // أضف هذا الاستيراد
export default function eventsTableData(eventCategory, handleEditClick, fetchEventCategory) {
  const handleDeletion = async (eventCategory) => {
    // رسالة تأكيد احترافية
    const result = await Swal.fire({
      title: "هل أنت متأكد؟",
      text: `سيتم حذف المكان التاريخي "${eventCategory.name}" بشكل دائم!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d32f2f",
      cancelButtonColor: "#6c757d",
      confirmButtonText: "نعم، احذف!",
      cancelButtonText: "إلغاء",
      customClass: {
        title: "text-danger",
        confirmButton: "btn btn-danger mx-2",
        cancelButton: "btn btn-secondary mx-2",
      },
      buttonsStyling: true,
      reverseButtons: true,
      focusCancel: true,
      showLoaderOnConfirm: true,
      preConfirm: async () => {
        try {
          const token = localStorage.getItem("user-token");
          const response = await axios.get(
            `${BASE_URL}/events/delete/${eventCategory.id}`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
          return response.data;
        } catch (error) {
          Swal.showValidationMessage(
            `فشل الحذف: ${error.response?.data?.message || error.message}`
          );
          return false;
        }
      },
    });

    // معالجة النتيجة
    if (result.isConfirmed) {
      if (result.value?.status) {
        Swal.fire({
          icon: "success",
          title: "تم الحذف!",
          text: "تم حذف المكان التاريخي بنجاح",
        });
        fetchEventCategory();
      } else {
        Swal.fire({
          title: "فشل الحذف!",
          text: result.value?.message || "حدث خطأ غير متوقع",
          icon: "error",
        });
      }
    }
  };
  const Name = ({ name, image }) => (
    <MDBox display="flex" alignItems="center" lineHeight={1}>
      <MDAvatar
        src={image}
        name={name}
        size="sm"
        sx={{
          // 1. الخلفية الرمادية عند عدم وجود صورة
          backgroundColor: !image ? "grey.300" : "rgba(0, 0, 0, 0)",
          // 2. تحديد الحجم الجديد
          width: 40,
          height: 40,
          // 3. التأكد من الشكل الدائري
          borderRadius: "50%",
          // 4. تنسيق محتوى الأيقونة
          "& .MuiSvgIcon-root": {
            fontSize: "1rem", // تكبير حجم الأيقونة
          },
        }}
      >
        {!image && <PersonIcon fontSize="small" />}
      </MDAvatar>
      <MDBox ml={2} lineHeight={1}>
        <MDTypography display="block" variant="button" fontWeight="medium">
          {name}
        </MDTypography>
      </MDBox>
    </MDBox>
  );
  return {
    columns: [
      { Header: "اسم الفعالية", accessor: "name", width: "18%", align: "left" },
      { Header: "تصنيف الفعالية", accessor: "event_category", width: "12%", align: "left" },
      { Header: "البداية", accessor: "start_datetime", width: "12%", align: "center" },
      { Header: "النهاية", accessor: "end_datetime", width: "12%", align: "center" },
      { Header: "السوق", accessor: "market", width: "10%", align: "left" },
      { Header: "الموقع التاريخي", accessor: "historical_place", width: "10%", align: "left" },
      { Header: "الحالة", accessor: "status", width: "8%", align: "center" },
      { Header: "الصور", accessor: "images", width: "10%", align: "center" },
      { Header: "الإجراءات", accessor: "action", align: "center" },
    ],

    rows: eventCategory.map((event) => ({
      name: (
        <MDTypography variant="button" fontWeight="bold">
          {event.name}
        </MDTypography>
      ),
      event_category: (
        <MDTypography variant="caption" color="text" fontWeight="medium">
          {event.event_category?.name || "-"}
        </MDTypography>
      ),
      start_datetime: (
        <MDTypography variant="caption" color="text" fontWeight="medium">
          {event.start_datetime ? new Date(event.start_datetime).toLocaleString("ar-EG") : "-"}
        </MDTypography>
      ),
      end_datetime: (
        <MDTypography variant="caption" color="text" fontWeight="medium">
          {event.end_datetime ? new Date(event.end_datetime).toLocaleString("ar-EG") : "-"}
        </MDTypography>
      ),
      market: (
        <MDTypography variant="caption" color="text" fontWeight="medium">
          {event.market?.name || "-"}
        </MDTypography>
      ),
      historical_place: (
        <MDTypography variant="caption" color="text" fontWeight="medium">
          {event.historical_place?.name || "-"}
        </MDTypography>
      ),
      status: (
        <MDBadge
          badgeContent={
            event.status === "scheduled"
              ? "مجدولة"
              : event.status === "ongoing"
                ? "جارية"
                : event.status === "finished"
                  ? "منتهية"
                  : event.status
          }
          color={
            event.status === "scheduled"
              ? "info"
              : event.status === "ongoing"
                ? "success"
                : event.status === "finished"
                  ? "error"
                  : "secondary"
          }
          variant="gradient"
          size="sm"
        />
      ),
      images: (
        <MDBox display="flex" gap={0.5}>
          {(event.images || []).slice(0, 3).map((img, idx) => (
            <MDAvatar
              key={idx}
              src={img}
              size="xs"
              variant="rounded"
              sx={{ border: "1px solid #eee" }}
            />
          ))}
          {event.images && event.images.length > 3 && (
            <MDTypography variant="caption" color="text" fontWeight="bold">
              +{event.images.length - 3}
            </MDTypography>
          )}
        </MDBox>
      ),
      action: (
        <MDBox
          display="flex"
          alignItems="center"
          gap={1}
          p={1}
          borderRadius="lg"
          bgcolor="background.paper"
          boxShadow={1}
        >
          <IconButton
            aria-label="edit"
            sx={{
              color: "info.main",
              "&:hover": {
                transform: "scale(1.1)",
                transition: "transform 0.2s",
              },
            }}
            onClick={() => handleEditClick(event)}
          >
            <EditIcon fontSize="medium" />
          </IconButton>
          <IconButton
            aria-label="delete"
            sx={{
              color: "error.main",
              "&:hover": {
                transform: "scale(1.1)",
                transition: "transform 0.2s",
              },
            }}
            onClick={() => handleDeletion(event)}
          >
            <DeleteIcon fontSize="medium" />
          </IconButton>
        </MDBox>
      ),
    })),
  };
}
